import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AdvancedFilterFieldTypesEnum, IAdvancedFilterListItem} from '../../../../shared/advanced-filters/components/advance-filter';

import {IMetadataItemDto, MetaDataTypeEnum} from '../../../settings/documentfields/metadata-item.dto';
import {HttpActionState} from '../../../users/userslisting/store/users-listing.reducers';
import {ContractControlAdvanceFilterParamType, ContractControlGeneralDataTypeEnum} from '../../advanced-filters';
import {ContractControlKey} from '../contract-control.config';
import {ContractControlState} from '../states/ContractControlState';


export const contractControlState = createFeatureSelector<ContractControlState>(ContractControlKey);

export const advancedFilterList = createSelector(contractControlState, state => createFilterList(state.metadata?.data, state.advancedFilterSearch)  );
export const isAdvancedFiltersListLoading = createSelector(contractControlState, state=> state.advancedFilterRequestState === HttpActionState.Busy);
export const advancedFilterSearch = createSelector(contractControlState, state => state.advancedFilterSearch);
export const advancedFilterPage = createSelector(contractControlState, state => state.advancedFilterPage);

export const filters = createSelector(contractControlState, state => state?.appliedAdvancedFilters);
export const appliedAdvancedFilters = createSelector(filters, x=>x ?? []);

export const customColumnSettings = createSelector(contractControlState, state => state?.customColumnSettings);

function matchIconFor(y: IMetadataItemDto):string {
    switch (y.meta_data_type){
        case MetaDataTypeEnum.text:
            return 'type';
        case MetaDataTypeEnum.droplist:
            return 'droplet';
        case MetaDataTypeEnum.checkbox:
            return 'check-square'
        case MetaDataTypeEnum.datepicker:
            return 'calendar';
    }

    return '';
}

function createFilterList(data: IMetadataItemDto[] | undefined, advancedFilterSearch: string) {
    return [
        ...constAdvancedFilters.filter(x=> advancedFilterSearch?.trim().length > 0 ? x.text?.toLowerCase().indexOf(advancedFilterSearch.toLowerCase()) > 0: true),
        ...(data?.filter(x=>x.section === AdvancedFilterFieldTypesEnum.document_field)
            .map(y => ({
                group: y.section,
                text: y.meta_data_name,
                icon: matchIconFor(y),
                field_type: y.section as AdvancedFilterFieldTypesEnum,
                source: y
            })) || [])
    ];
}

export const constAdvancedFilters: IAdvancedFilterListItem<ContractControlAdvanceFilterParamType>[] = [
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Start Date",
        icon: 'calendar',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.start_date
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "End date",
        icon: 'calendar',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.end_date
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Ongoing",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.ongoing
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Monthly cost",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.monthly_cost
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Annual cost",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.annual_cost
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Total cost",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.total_cost
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Monthly revenue",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.monthly_revenue
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Annual revenue",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.annual_revenue
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Total revenue",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.total_revenue
        } as ContractControlAdvanceFilterParamType,
    },
    {
        group: AdvancedFilterFieldTypesEnum.general_field,
        text: "Auto renewal date",
        icon: 'edit',
        field_type: AdvancedFilterFieldTypesEnum.general_field,
        source: {
            general_data_type: ContractControlGeneralDataTypeEnum.auto_renewal_date
        } as ContractControlAdvanceFilterParamType,
    },

];
